import { render, staticRenderFns } from "./nxUser.vue?vue&type=template&id=2973a72e&scoped=true&"
import script from "./nxUser.vue?vue&type=script&lang=js&"
export * from "./nxUser.vue?vue&type=script&lang=js&"
import style0 from "./nxUser.vue?vue&type=style&index=0&id=2973a72e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2973a72e",
  null
  
)

export default component.exports